import { get, find, every } from 'lodash';
import { MODELS } from '../constants/admin/settings';
import { CONTRACT_STATE_SIGNED, NO_SIGNERS_TEXT, LOADING_TEXT, CONTRACT_TYPES } from '../constants/settings';
import { requireUseUntil } from '../selectors/admin/models/lineup';
import { relatedToFromFunction } from '../selectors/admin/models/permissions';

export function validateOrganization(data) {
    return data.name && data.name.length > 4 && data.timeZone;
}

export function validateEvent(data) {
    return data.name && data.organizationId && data.timeZone;
}

export function validatePartner(data) {
    return data.name && data.timeZone && data.category;
}

export function validateBulkpartnersemail(data) {
    return data && !!data.text;
}

export function validateContractreminder() {
    return true;
}

export function validateContractupload(data) {
    return data && data.file && data.state;
}

export function validateEventemailsender(data) {
    return data && data.name && data.email;
}

export function validateUser(data, isUpdate) {
    return (
        data.email &&
        data.firstName &&
        data.firstName.length > 2 &&
        data.lastName &&
        data.lastName.length > 2 &&
        data.roleId &&
        (isUpdate ? true : data.organizationId || data.partnerId)
    );
}

export function validateContact(data) {
    return data.fullName && data.fullName.length > 1 && data.email;
}

export function validatePermission(data) {
    const relatedTo = relatedToFromFunction(data.function);
    const orgRequire = relatedTo === MODELS.ARTIST || relatedTo === MODELS.PARTNER;
    return (orgRequire ? data.orgId : true) && data.function && data.group && data.name && data.eventId;
}

export function validateArtist(data) {
    return data.name;
}

export function validateCopypartnerclearance(data) {
    return data.partnerId;
}

export function validateContract(data, isUpdate, dependencies) {
    const selectedEvent = find(dependencies.events, d => d.id === data.eventId);
    const validateSignature =
        selectedEvent &&
        (data.type === CONTRACT_TYPES.CLEARANCE
            ? selectedEvent.defaultSignature && selectedEvent.defaultSigner
            : selectedEvent.performanceSignature && selectedEvent.performanceSigner);

    return (
        validateSignature &&
        data.artistId &&
        data.dueDate &&
        data.signers !== LOADING_TEXT &&
        data.signers !== NO_SIGNERS_TEXT &&
        !data.editing &&
        _isLatestContractVersion(data, isUpdate, dependencies) &&
        !_isSigned(data)
    );
}

export function validateContractdraft(data, isUpdate, dependencies) {
    return !data.editing && data.artistId && data.eventId && _isLatestContractVersion(data, isUpdate, dependencies);
}

export function validateContractpartner(data) {
    return data.partnerId && data.live && data.nonLinear;
}

export function validateTemplate(data) {
    return data.name && data.data && data.organizationId && data.type;
}

export function validateStage(data) {
    return data.number && data.dates && data.dates.length && every(data.dates, x => data[`name${x}`]);
}

export function validateEventpartner(data) {
    return data.partnerIds.length;
}

export function validateEventartist(data) {
    return data.artistIds.length || data.eventIds.length;
}

export function validateBulkperformance(data) {
    return data.live || data.nonLinear || data.comments || data.useUntil;
}

export function validateScheduledentry(data, isUpdate, dependencies) {
    return (
        data.stageIdentifier &&
        data.end &&
        data.start &&
        data.artistId &&
        data.end > data.start &&
        every(data.states || [], s => {
            const linearName = get(
                find(dependencies.linearStates, ls => ls.id === s.linearStateId),
                'name'
            );
            return requireUseUntil(linearName) ? !!s.linearUseUntil : true;
        })
    );
}

export function validateEventreminder(data) {
    return data.name && data.contractType && data.dueDate;
}
// PRIVATE
const _isLatestContractVersion = (data, update, deps) =>
    !update || get(deps, 'versions[0].id') === get(data, 'version.id');

const _isSigned = data => get(data, 'version.state') === CONTRACT_STATE_SIGNED;



// WEBPACK FOOTER //
// ./src/lib/validation.utils.js